import { useEffect, useState } from "react";

// Detects if the user is on a device with a fine pointer (mouse/trackpad).
// We use this to gate cursor glow + magnetic hover interactions.
export const useHasFinePointer = () => {
    const [fine, setFine] = useState(false);
    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return;
        const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
        const update = () => setFine(mq.matches);
        update();
        mq.addEventListener?.("change", update);
        return () => mq.removeEventListener?.("change", update);
    }, []);
    return fine;
};
